import Helper from "../../playcreator/functions/Helper.js";

const getGridLines = (spacing, court) => {
  let { maxX, maxY } = Helper.getMaxCoordinates(court);
  let vertical = [0];
  for (let i = spacing; i < maxX; i += spacing) {
    vertical.push(i);
    vertical.push(-i);
  }

  let horizontal = [0];
  for (let i = spacing; i < maxY; i += spacing) {
    horizontal.push(i);
    horizontal.push(-i);
  }

  return {
    vertical,
    horizontal,
  };
};

export default function Grid({ spacing = 6, court, pixelPerFoot, courtColor }) {
  let gridLines = getGridLines(spacing, court);
  let { minX, maxX, minY, maxY } = Helper.getMaxCoordinates(court);
  let strokeColor =
    courtColor.backgroundColor === "white"
      ? "rgba(0,0,0,0.1)"
      : "rgba(255,255,255,0.4)";

  return (
    <g>
      {gridLines.vertical.map((x, index) => (
        <line
          key={index}
          x1={x}
          y1={minY}
          x2={x}
          y2={maxY}
          stroke={strokeColor}
          strokeWidth={1 / pixelPerFoot}
        />
      ))}

      {gridLines.horizontal.map((y, index) => (
        <line
          key={index}
          x1={minX}
          y1={y}
          x2={maxX}
          y2={y}
          stroke={strokeColor}
          strokeWidth={1 / pixelPerFoot}
        />
      ))}
    </g>
  );
}
